module.exports = __webpack_public_path__ + "img/meuble.0f2a2c6.svg";